// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../.yarn/__virtual__/css-loader-virtual-8b8790ede6/0/cache/css-loader-npm-7.1.2-7540f12884-ddde22fb10.zip/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../.yarn/__virtual__/css-loader-virtual-8b8790ede6/0/cache/css-loader-npm-7.1.2-7540f12884-ddde22fb10.zip/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tippy-box[data-animation=fade][data-state=hidden] {
    opacity: 0
}

[data-tippy-root] {
    max-width: calc(100vw - 10px);
    box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.05), 0 24px 38px 3px rgba(0, 0, 0, 0.03), 0 9px 46px 8px rgba(0, 0, 0, 0.02);
}

.tippy-box {
    position: relative;
    background-color: white;
    color: #23232d;
    border-radius: 4px;
    font-size: 14px;
    line-height: 1.4;
    outline: 0;
    transition-property: transform, visibility, opacity;
    box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.05), 0 24px 38px 3px rgba(0, 0, 0, 0.03), 0 9px 46px 8px rgba(0, 0, 0, 0.02);
}

.tippy-box.helper-tippy {
    padding: 10px;
}

.tippy-box.export-tippy {
    padding: 0;
}

.tippy-box[data-placement^=top]>.tippy-arrow {
    bottom: 0
}

.tippy-box[data-placement^=top]>.tippy-arrow:before {
    bottom: -7px;
    left: 0;
    border-width: 8px 8px 0;
    border-top-color: initial;
    transform-origin: center top
}

.tippy-box[data-placement^=bottom]>.tippy-arrow {
    top: 0
}

.tippy-box[data-placement^=bottom]>.tippy-arrow:before {
    top: -7px;
    left: 0;
    border-width: 0 8px 8px;
    border-bottom-color: initial;
    transform-origin: center bottom
}

.tippy-box[data-placement^=left]>.tippy-arrow {
    right: 0
}

.tippy-box[data-placement^=left]>.tippy-arrow:before {
    border-width: 8px 0 8px 8px;
    border-left-color: initial;
    right: -7px;
    transform-origin: center left
}

.tippy-box[data-placement^=right]>.tippy-arrow {
    left: 0
}

.tippy-box[data-placement^=right]>.tippy-arrow:before {
    left: -7px;
    border-width: 8px 8px 8px 0;
    border-right-color: initial;
    transform-origin: center right
}

.tippy-box[data-inertia][data-state=visible] {
    transition-timing-function: cubic-bezier(.54, 1.5, .38, 1.11)
}

.tippy-arrow {
    width: 16px;
    height: 16px;
    color: white;
}

.tippy-arrow:before {
    content: "";
    position: absolute;
    border-color: transparent;
    border-style: solid
}

.tippy-content {
    position: relative;
    padding: 5px 9px;
    z-index: 1
}

*[id^='tippy-'] {
    pointer-events: initial !important;
}
`, "",{"version":3,"sources":["webpack://./web/src/common/app/styles/tippy.css"],"names":[],"mappings":"AAAA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,yHAAyH;AAC7H;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,mDAAmD;IACnD,yHAAyH;AAC7H;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,OAAO;IACP,uBAAuB;IACvB,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT,OAAO;IACP,uBAAuB;IACvB,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,2BAA2B;IAC3B,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,kCAAkC;AACtC","sourcesContent":[".tippy-box[data-animation=fade][data-state=hidden] {\n    opacity: 0\n}\n\n[data-tippy-root] {\n    max-width: calc(100vw - 10px);\n    box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.05), 0 24px 38px 3px rgba(0, 0, 0, 0.03), 0 9px 46px 8px rgba(0, 0, 0, 0.02);\n}\n\n.tippy-box {\n    position: relative;\n    background-color: white;\n    color: #23232d;\n    border-radius: 4px;\n    font-size: 14px;\n    line-height: 1.4;\n    outline: 0;\n    transition-property: transform, visibility, opacity;\n    box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.05), 0 24px 38px 3px rgba(0, 0, 0, 0.03), 0 9px 46px 8px rgba(0, 0, 0, 0.02);\n}\n\n.tippy-box.helper-tippy {\n    padding: 10px;\n}\n\n.tippy-box.export-tippy {\n    padding: 0;\n}\n\n.tippy-box[data-placement^=top]>.tippy-arrow {\n    bottom: 0\n}\n\n.tippy-box[data-placement^=top]>.tippy-arrow:before {\n    bottom: -7px;\n    left: 0;\n    border-width: 8px 8px 0;\n    border-top-color: initial;\n    transform-origin: center top\n}\n\n.tippy-box[data-placement^=bottom]>.tippy-arrow {\n    top: 0\n}\n\n.tippy-box[data-placement^=bottom]>.tippy-arrow:before {\n    top: -7px;\n    left: 0;\n    border-width: 0 8px 8px;\n    border-bottom-color: initial;\n    transform-origin: center bottom\n}\n\n.tippy-box[data-placement^=left]>.tippy-arrow {\n    right: 0\n}\n\n.tippy-box[data-placement^=left]>.tippy-arrow:before {\n    border-width: 8px 0 8px 8px;\n    border-left-color: initial;\n    right: -7px;\n    transform-origin: center left\n}\n\n.tippy-box[data-placement^=right]>.tippy-arrow {\n    left: 0\n}\n\n.tippy-box[data-placement^=right]>.tippy-arrow:before {\n    left: -7px;\n    border-width: 8px 8px 8px 0;\n    border-right-color: initial;\n    transform-origin: center right\n}\n\n.tippy-box[data-inertia][data-state=visible] {\n    transition-timing-function: cubic-bezier(.54, 1.5, .38, 1.11)\n}\n\n.tippy-arrow {\n    width: 16px;\n    height: 16px;\n    color: white;\n}\n\n.tippy-arrow:before {\n    content: \"\";\n    position: absolute;\n    border-color: transparent;\n    border-style: solid\n}\n\n.tippy-content {\n    position: relative;\n    padding: 5px 9px;\n    z-index: 1\n}\n\n*[id^='tippy-'] {\n    pointer-events: initial !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
